export const isOutlined = (classNames: string[]) =>
  (classNames.includes("chipOutlinePrimary") ||
    classNames.includes("chipOutlineSecondary") ||
    classNames.includes("chipOutlineNeutralLighter") ||
    classNames.includes("chipOutlineNeutralDarker") ||
    classNames.includes("chipOutlineSuccess") ||
    classNames.includes("chipOutlineWarning") ||
    classNames.includes("chipOutlineDanger") ||
    classNames.includes("chipOutlineInfo")) as boolean;
